// import { apolloClient } from 'vue-apollo';
/* eslint-disable*/
// import query_posts from "../../queries/posts.js"
import { apolloClient } from '@/vue-apollo'
import gql from 'graphql-tag';
import { onLogout } from '../../vue-apollo';
import apolloProvider from "../../main.js";

const state = {
    posts: []
}

const getters = {
    getUserPosts:(state)=>{
        return state.posts;
    }
}

const actions = {
    getPosts:async({commit}, user)=>{
        const response = await this.$provide.query({
            query: gql`
            query getUserPosts {
                user_post {
                  date_posted
                  post_id
                  post_url
                  public
                  user_id
                }
              }`
          })
          console.log(response.data)
    },
    setLogin({commit}, user){
        console.log(apolloClient);
        let session_start = new Date;
        let token = localStorage.getItem("apollo-token");
        apolloClient.mutate({
            mutation: gql`
              mutation insertLogin($user_id: String!, $user_email: String, $login_time: timestamp, $login_status: String) {
              insert_user_logins_one(object: {user_id: $user_id, user_email: $user_email, login_time: $login_time, login_status: $login_status}) {
                  login_id
                  login_time
                  user_email
                  login_status
                }
              }
            `,
            variables: {
              user_id: user.user.uid,
              login_time: session_start,
              user_email: user.user_email,
              login_status: "in"
            }
          }, token);       
    }
}

const mutations = {
    SET_POSTS:(state, data)=>{
        console.log(data);
        state.posts = data;
    }
}

export default {
  state,
  getters,
  actions,
  mutations
}